import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import RecurrencyConfig from './RecurrencyConfig';
import AlertsNotificationsModal from './AlertsNotificationsModal';

class DropdownDeOpciones extends Component {

    constructor() {
        super();

        this.state = {
            dropdownIsOpen: false,
            recurrencyConfigModalIsOpen: false,
            alertsNotificationsModalIsOpen: false
        }
    }

    render() {
        return (
            <React.Fragment>

                <p>{this.props.downloadSource.name === 'deudores_alimentario' ? JSON.stringify(this.props.downloadSource): ''}</p>
                <Dropdown isOpen={this.state.dropdownIsOpen} title="Opciones"
                    toggle={() => { this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen }) }}>
                    <DropdownToggle nav style={{ padding: 0 }}>
                        <i className="fas fa-ellipsis-v" style={{ paddingLeft: 15, paddingTop: 8, color: "#66615b" }} />
                    </DropdownToggle>

                    <DropdownMenu right>
                        <DropdownItem style={{ cursor: "pointer" }} onClick={() => {
                            localStorage.setItem('lastVisitedRoute', JSON.stringify('/admin/reportes?source_id=' + this.props.downloadSource.id));
                            this.props.history.push('/admin/reportes?source_id=' + this.props.downloadSource.id)
                        }}>
                            Historial de descargas
                    </DropdownItem>

                        {this.getConfigurationLink()}
                        
                        {this.props.downloadSource.programmable ? this.getRecurrencyConfigButton() : null}

                        <DropdownItem style={{ cursor: "pointer" }} onClick={this.alertsNotificationsModalToggle}>
                            Alertas y Notificaciones
                        </DropdownItem>

                    </DropdownMenu>
                </Dropdown>

                <RecurrencyConfig
                    downloadSource={this.props.downloadSource}
                    modalToggle={this.recurrencyConfigModalToggle}
                    isOpen={this.state.recurrencyConfigModalIsOpen}
                    reloadSourcesMethod={this.props.reloadSourcesMethod} />
                    
                <AlertsNotificationsModal
                    onRef={ref => this.alertsNotificationsModal = ref}
                    downloadSource={this.props.downloadSource} />
            </React.Fragment>
        );
    }

    //Métodos operativos
    recurrencyConfigModalToggle = () => {
        this.setState({ recurrencyConfigModalIsOpen: !this.state.recurrencyConfigModalIsOpen });
    }
    
    alertsNotificationsModalToggle = () => {
        if (this.alertsNotificationsModal) {
            this.alertsNotificationsModal.modalToggle();
        }
    }

    //Métodos para renderizado:
    getConfigurationLink = () => {
        if (this.props.activeUser.is_admin || this.props.activeUser.is_staff) {
            return (
                <DropdownItem style={{ cursor: "pointer" }} onClick={() => {
                    localStorage.setItem('lastVisitedRoute', JSON.stringify('/admin/configuracion?source_id=' + this.props.downloadSource.id));
                    this.props.history.push('/admin/configuracion?source_id=' + this.props.downloadSource.id)
                }}>
                    Parametrización de descarga
                </DropdownItem>
            );
        }
    }

    getRecurrencyConfigButton = () => {
        if (this.props.activeUser.is_admin || this.props.activeUser.is_staff) {
            return (
                <DropdownItem style={{ cursor: "pointer" }} onClick={this.recurrencyConfigModalToggle}>
                    Programación de descargas
                </DropdownItem>
            );
        }
    }
}

const mapStateToProps = state => {
    return { activeUser: state.mainReducer.activeUser, };
};

export default connect(mapStateToProps)(withRouter(DropdownDeOpciones));